import { Image } from "@fla/components";
import Logo from "assets/images/logo-1x.webp";
import Logo3x from "assets/images/logo-3x.webp";
import { FC } from "react";

import { LayoutProps } from "./Layout.types";

export const AuthLayout: FC<LayoutProps> = ({ children, bgColor }) => {
  return (
    <main className={`min-w-full h-screen ${bgColor} overflow-y-auto grid grid-cols-7`}>
      <div className="col-span-7 lg:col-span-2 flex flex-col items-center lg:items-end justify-center lg:pr-20">
        <Image width="11rem" className="w-44 h-auto" placeholderSrc={Logo} src={Logo3x} />
      </div>
      <div className="col-span-7 lg:col-span-5 bg-white flex flex-col justify-start lg:justify-center items-center lg:items-start px-10 pt-20 lg:pt-0 lg:pl-20 ">
        {children}
      </div>
    </main>
  );
};
